/**
 * @desc outDeliveryWriteBack
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InDeliveryWriteBackDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/out/write`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
